export default __webpack_public_path__ + "static/media/USDN3CRV.14c662ea.png";